import { enumType } from '@shared/core/types/common';

enum ADDRESS_PROVIDER {
    GOOGLE = OLO.Enums.ADDRESS_PROVIDER.GOOGLE,
    // Currently not supported
    // EXPERIAN = OLO.Enums.ADDRESS_PROVIDER.EXPERIAN,
}

export const addressProviderEnum = enumType('ADDRESS_PROVIDER', ADDRESS_PROVIDER);
